import React from "react";
import styled from "styled-components";
import { Colors, TextFont } from "../../../config";

const BaggageDetail = ({ heading, quantity }) => {
  return (
    <EachBaggage>
      <TextFont fontColor={Colors.sharkOpacity50} fontSize="0.875rem">
        {heading}
      </TextFont>
      <TextFont
        fontColor={Colors.martinique}
        fontSize="0.875rem"
        fontWeight="700"
      >
        {quantity}
      </TextFont>
    </EachBaggage>
  );
};

export default BaggageDetail;
const EachBaggage = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
  align-items: flex-end;
`;
